import PropTypes from 'prop-types';
import GridOptions from './GridOptions';
import MuiGrid from '../../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../../shared/icons';
import MyButton from '../../../../UI/myButton/MyButton';
import CheckBox from '../../../../UI/FormControls/CheckBox';

const GridProvider = ({
  data,
  handleOpenDeleteDialog,
  handleOpenDialogForm,
  handleOpenMultiDialog,
  isLoading,
}) => {
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: 'Opcije',
      width: 70,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <GridOptions
          handleOpenDialog={() => handleOpenDeleteDialog(e.id)}
          getEditData={() => handleOpenDialogForm(e.row)}
        >
          <button className="header-options">{icons.MENU_ICON}</button>
        </GridOptions>
      ),
    },
    { field: 'proveravanaStavka', headerName: 'Stavka', width: 400 },
    // { field: 'naziv', headerName: 'Naziv', width: 400 },
    {
      field: 'cekirano',
      headerName: 'Čekirano',
      width: 120,
      renderCell: (e) => (
        <div style={{ textAlign: 'center', width: '100%' }}>
          <CheckBox style={{ height: '36px' }} checked={e.row.cekirano} />
        </div>
      ),
    },
    { field: 'napomena', headerName: 'Napomena', width: 600 },
    // { field: 'cena', headerName: 'Cena koštanja', width: 150 },
    // { field: 'iznos', headerName: 'Cena prema klijentu', width: 200 },
    // { field: 'napomena', headerName: 'Napomena', width: 300 },
  ];

  return (
    <div style={{ height: '52vh', width: '99%' }}>
      <MyButton
        label="Novi unos"
        style={{ marginBottom: '5px' }}
        onClick={() => handleOpenDialogForm({})}
      />
      <MyButton
        label="Izbor stavke"
        style={{ marginBottom: '5px' }}
        onClick={() => handleOpenMultiDialog()}
      />
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

GridProvider.propTypes = {
  data: PropTypes.array.isRequired,
  handleOpenDeleteDialog: PropTypes.func.isRequired,
  handleOpenDialogForm: PropTypes.func.isRequired,
};

export default GridProvider;
